import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Attribute, AttributeCreate, AttributeFilter } from '../data/attribute';

export function createAttributeService(client: AxiosInstance) {
  return createCrudService<Attribute, AttributeCreate, AttributeFilter>(client, '/Attribute', 'attributeId');
}

export type AttributeService = CrudService<Attribute, AttributeCreate, AttributeFilter>;
